import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { ProfileImageUpload } from "../../shared/models/ProfileImageUpload";
// import { FileUploadService } from 'src/app/services/file-upload.service';
import { FileUploadVerService } from "../../shared/service/fileUploadVer.service";
import { Profile_File_Types } from "../../shared/UploadFileTypes";
import { dataService } from "../../shared/service/dataservice.service";
import { OnboardingService } from "../../shared/service/onboarding.service";

@Component({
  selector: "app-edit-avatarVer",
  templateUrl: "./edit-avatarVer.component.html",
  styleUrls: ["./edit-avatarVer.component.scss"],
})
export class EditAvatarVerComponent implements OnInit {
  profileImageUpload: any;
  MAX_SIZE: number = 1048576;
  @ViewChild("avatarImg", { static: true }) avatarImgElement: ElementRef;
  @Input() photo: string;
  @Input() empId: any;
  @Input() EmpId: any;
  @Output() photoUpdated = new EventEmitter<string>();
  @Input() isProfile: boolean;

  showAddPhotoOverlay = false;
  imageInfos?: Observable<any>;
  FileAsBase64: string | ArrayBuffer;

  constructor(
    private uploadService: FileUploadVerService,
    private file_Svc: FileUploadVerService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private dataservice: dataService,
    public _service: OnboardingService
  ) {
    this.route.params.subscribe((params) => {
      this.empId = params["empId"];
    });
  }

  ngOnInit(): void {
    this.profileImageUpload = new ProfileImageUpload();
    this.uploadService
      .getUserProfileDetails(this.empId)
      .subscribe((data: any) => {
        this.imageInfos = data.Base64Profile || data.ProfileFilePath;
        this.photo = data.Base64Profile || data.ProfileFilePath;
        this.photoUpdated.emit(this.photo);
      });
  }

  addPhoto(event) {
    const fileReader = new FileReader();
    if (event.target.files == undefined) {
      this.profileImageUpload = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        fileReader.onload = () => {
          this.avatarImgElement.nativeElement.src = fileReader.result;
          this.FileAsBase64 = fileReader.result.toString();
          this.profileImageUpload = this.file_Svc
            .profileUpload(
              files,
              this.avatarImgElement.nativeElement.src,
              this.empId
            )
            .subscribe((data: any) => {
              this.uploadService
                .getUserProfileDetails(this.empId)
                .subscribe((data: any) => {
                  this.imageInfos = data.Base64Profile || data.ProfileFilePath;
                  this.photo = data.Base64Profile || data.ProfileFilePath;
                  this.photoUpdated.emit(this.photo);
                });
            });
        };
      } else {
        this.toastr.warning(
          " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
        );
        //  Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
    fileReader.readAsDataURL(event.target.files[0]);
  }

  validFileType(file) {
    let types = Profile_File_Types;
    return types.includes(file.type);
  }

  openFileInput(fileInput) {
    fileInput.click();
    this.showAddPhotoOverlay = false;
  }

  downloadProfilePic() {
    this.uploadService
      .getUserProfileDetails(this.empId)
      .subscribe((data: any) => {
        var url = this.file_Svc.downloadImage(
          data.Base64Profile,
          data.ProfileFileName
        );
      });

    // window.open(url);
  }

  removePhoto() {
    this.avatarImgElement.nativeElement.src = "";
    this.photo = "";
    this.photoUpdated.emit(this.photo);
  }

  getHrEmpDtlsOutput(val) {}
}
